import { useSelectedBusiness } from "../../UserAccess/useSelectedBusiness";
import { HttpMethod } from "../../Common/useFetch";
import useUserRequest from "../../Common/useUserRequest";
import { RequestOptions } from "../../Common/useRequest";
import { PurchaseOrderSettingsDto } from "./useGetPurchaseOrderSettings";

const useUpdatePurchaseOrderSettings = (options?: RequestOptions) => {
  const business = useSelectedBusiness();

  return useUserRequest<PurchaseOrderSettingsDto>({
    path: `/api/businesses/${business.id}/purchaseOrderSettings`,
    method: HttpMethod.PUT,
  }, options);
}

export default useUpdatePurchaseOrderSettings;
